<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Kontak</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="/home">Home</a>
            </div>
            <div class="breadcrumb-item">
              Kontak
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-header">
              <h4 class="d-inline">
                Kontak
              </h4>
            </div>
            <div
              class="card-body"
              style="overflow:hidden"
            >
              <div class="row">
                <div class="col-lg-8">
                  <div class="form-group">
                    <label for="">Judul</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.judul_page"
                      disabled
                    >
                  </div>
                  <div class="form-group">
                    <label for="">Konten</label>
                    <vue-editor v-model="form.konten_page" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary"
                    @click="previewPage"
                  >
                    <i class="fa fa-check mr-2" />
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <b-modal
      id="modal-preview-page"
      title="Preview Page"
      hide-footer
      size="lg"
    >
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <tr>
            <td style="width:200px">
              Judul
            </td>
            <td>{{ form.judul_page }}</td>
          </tr>
        </table>
      </div>

      <div
        v-html="form.konten_page"
        class="p-1"
        style="border:1px solid #eee"
      />

      <div class="text-right mt-3">
        <button
          id="btnSimpanPage"
          class="btn btn-primary mx-1"
          @click="simpanPage"
        >
          <i class="fa fa-check mr-2" />
          Simpan
        </button>
        <button
          class="btn btn-danger mx-1"
          @click="$bvModal.hide('modal-preview-page')"
        >
          <i class="fa fa-times mr-2" />
          Tutup
        </button>
      </div>
    </b-modal>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import swal from 'sweetalert'
import LayoutAdmin from '../layouts/Admin.vue'
import { VueEditor } from 'vue2-editor'

export default {
	name: 'App',
	data(){
	return {
		form: {
			judul_page: '',
			konten_page: '',
		},
		idPageShow: 0,
		previewThumbnail: '',
	}
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
	},
	components: {
		LayoutAdmin, VueEditor
	},
	methods: {
		previewPage(){
			this.$bvModal.show('modal-preview-page')
		},
		simpanPage(){
			let button = document.querySelector('#btnSimpanPage')
			let buttonHtml = button.innerHTML

			button.setAttribute('disabled', true)
			button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

			let formData = new FormData()
			for(let key in this.form){
				let val = ( this.form[key] ) ? this.form[key] : ''
				formData.append(key, val)
			}

			let form = {
				id: this.idPageShow,
				form: formData
			}

			this.$store.dispatch('updatePage', form).then(res => {
				if(res.data.status){
					swal({
						title: "Berhasil",
						text: res.data.message,
						icon: "success",
						buttons: "Ok"
					})
					this.$bvModal.hide('modal-preview-page')
				} else {
					swal({
						title: "Gagal",
						text: res.data.message,
						icon: "error",
						buttons: "Ok"
					})
				}
				button.removeAttribute('disabled')
				button.innerHTML = buttonHtml
			}).catch(err => {
				// console.log(err)
				switch(err.response.status){
					case 500:
						this.$router.push({path: '/500'})
						break;

					case 400:
						swal({
							title: "Gagal",
							text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
							icon: "error",
							buttons: "Ok"
						})
						break;
					
					default:
						swal({
							title: "Gagal",
							text: err.response.data.message,
							icon: "error",
							buttons: "Ok"
						})
						break;
				}
			})
		},
		setForm(data){
			this.form.judul_page = data.judul_page
			this.form.konten_page = data.konten_page

			this.idPageShow = data.id_page
		}
	},
	created(){
		this.$store.dispatch('showPage', this.$route.params.slug).then(res => {
			if(res.data.data){
				this.setForm(res.data.data)
			}
		})
	},
	mounted(){
		
	},
}
</script>

<style>

</style>
